<button
  mat-stroked-button
  [matMenuTriggerFor]="statusMenu"
  [disabled]="isUpdating()"
  class="text-xs flex items-center gap-1.5"
>
  @if (isUpdating()) {
    <mat-spinner diameter="14" class="mr-1 inline-block" />
  } @else {
    <mat-icon class="text-sm!">tune</mat-icon>
  }
  <span>Statut admin</span>
  <mat-icon class="text-xs! text-gray-11">arrow_drop_down</mat-icon>
</button>

<mat-menu #statusMenu="matMenu">
  <button
    mat-menu-item
    (click)="onSelectStatus(PropertyDocumentStatus.VERIFIED)"
    [disabled]="doc().status === PropertyDocumentStatus.VERIFIED"
  >
    <mat-icon class="text-jade-11!">check_circle</mat-icon>
    <span>Valider (conforme)</span>
  </button>
  <button
    mat-menu-item
    (click)="onSelectStatus(PropertyDocumentStatus.PENDING_REVIEW)"
    [disabled]="doc().status === PropertyDocumentStatus.PENDING_REVIEW"
  >
    <mat-icon class="text-indigo-11!">hourglass_top</mat-icon>
    <span>En attente d’analyse</span>
  </button>
  <button
    mat-menu-item
    (click)="onSelectStatus(PropertyDocumentStatus.REJECTED)"
    [disabled]="doc().status === PropertyDocumentStatus.REJECTED"
  >
    <mat-icon class="text-ruby-11!">cancel</mat-icon>
    <span>Rejeter (non conforme)</span>
  </button>
</mat-menu>
